import {createDeviceStore} from './createDeviceStore'

export default createDeviceStore('microphone')
